'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Element = require('react').babelPluginFlowReactPropTypes_proptype_Element || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

/**
 * This is the internal component used by checkbox and radio
 */
var SwitchBase = function (_React$Component) {
  _inherits(SwitchBase, _React$Component);

  function SwitchBase(props) {
    _classCallCheck(this, SwitchBase);

    var _this = _possibleConstructorReturn(this, (SwitchBase.__proto__ || Object.getPrototypeOf(SwitchBase)).call(this, props));

    _this.onChange = function (e) {
      if (_this.props.disabled) return;
      var checked = e.target.checked;
      if (!_this.isControlled) {
        _this.setState({ checked: checked });
      }
      if (_this.props.onChange) {
        _this.props.onChange(e, e.target.value, checked);
      }
    };

    _this.renderCheckbox = function (type, checked, checkedIcon, uncheckedIcon, defaultCheckedIcon) {
      if (checked && _react2.default.isValidElement(checkedIcon)) {
        return checkedIcon;
      }
      if (!checked && _react2.default.isValidElement(uncheckedIcon)) {
        return uncheckedIcon;
      }
      if (checked && type === 'checkbox') {
        return defaultCheckedIcon;
      }
      return null;
    };

    _this.isControlled = props.checked != null;
    _this.state = {};
    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }
    return _this;
  }

  _createClass(SwitchBase, [{
    key: 'render',
    value: function render() {
      var _ClassNames;

      var _props = this.props,
          name = _props.name,
          _props$type = _props.type,
          type = _props$type === undefined ? 'checkbox' : _props$type,
          style = _props.style,
          className = _props.className,
          checkedIcon = _props.checkedIcon,
          uncheckedIcon = _props.uncheckedIcon,
          defaultCheckedIcon = _props.defaultCheckedIcon,
          value = _props.value,
          checkedProp = _props.checked,
          disabled = _props.disabled,
          defaultChecked = _props.defaultChecked,
          onChange = _props.onChange,
          others = _objectWithoutProperties(_props, ['name', 'type', 'style', 'className', 'checkedIcon', 'uncheckedIcon', 'defaultCheckedIcon', 'value', 'checked', 'disabled', 'defaultChecked', 'onChange']);

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var renderCheckbox = this.renderCheckbox;

      var classes = (0, _classnames2.default)(className, 'a-' + type, (_ClassNames = {}, _defineProperty(_ClassNames, 'a-' + type + '-checked', checked), _defineProperty(_ClassNames, 'a-' + type + '-disabled', disabled), _ClassNames));
      return _react2.default.createElement(
        'span',
        { className: classes },
        _react2.default.createElement('input', Object.assign({
          name: name,
          type: type,
          checked: checked,
          disabled: disabled,
          onChange: this.onChange,
          style: style,
          value: value,
          className: 'a-' + type + '-input'
        }, others)),
        _react2.default.createElement(
          'span',
          { className: 'a-' + type + '-inner' },
          renderCheckbox(type, checked, checkedIcon, uncheckedIcon, defaultCheckedIcon)
        )
      );
    }
  }]);

  return SwitchBase;
}(_react2.default.Component);

exports.default = SwitchBase;